document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open);
  }
  const searchToggle = event.target.closest('[data-search-toggle]');
  if (searchToggle) {
    const panel = document.querySelector('[data-search-panel]');
    panel.hidden = !panel.hidden;
    if (!panel.hidden) panel.querySelector('input').focus();
  }
});

document.addEventListener('shopify:section:load', () => window.scrollTo(0, window.scrollY));
